import { injectIntl } from "react-intl";
import { Formik } from "formik";
import SubmitButton from "../Form/SubmitButton";
import intlShape from "../../shapes/intlShape";
import { Button, ObjectsTypeahead, Form } from "../Form";
import { ObjectsType } from "../../constants";

type Props = {
  intl: intlShape;
  onCloseDuplicate?: $TSFixMeFunction;
  onCreateDuplicate?: $TSFixMeFunction;
  duplicateTags: {
    id?: number;
    tag?: string;
  }[];
  onAssignDuplicate?: $TSFixMeFunction;
};

export function InstrumentationDuplicateMoreTags({
  intl,
  onCloseDuplicate,
  onCreateDuplicate,
  duplicateTags,
  onAssignDuplicate,
}: Props) {
  const validateForm = (values: $TSFixMe) => {
    const errors = {};

    if (!values.tag) {
      (errors as $TSFixMe).tag = intl.formatMessage({
        id: "validation.tag_selection.mandatory",
      });
    }
    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { isSubmitting } = formProps;
    return (
      <Form id="duplicate-form" {...formProps}>
        <span id="modal-text-1" className="space-after">
          {intl.formatMessage(
            { id: "instrumentation_assign.more_duplicates_modal_text1" },
            { tag: duplicateTags[0].tag },
          )}
        </span>
        <ObjectsTypeahead
          {...formProps}
          id="tag-typeahead"
          name="tag"
          placeholder={intl.formatMessage({ id: "label.tag" })}
          values={{}}
          filteredObjects={duplicateTags}
          objectsType={ObjectsType.FilteredInstrumentations}
        />
        <div className="btn-group space-before">
          <SubmitButton
            fetching={isSubmitting}
            id="assign-button"
            disabled={!formProps.values.tag}
            text={intl.formatMessage({ id: "button.assign" })}
          />
        </div>
        <span id="modal-text-2" className="space-after">
          {intl.formatMessage({
            id: "instrumentation_assign.more_duplicates_modal_text2",
          })}
        </span>
        <div className="btn-group space-before">
          <Button
            id="create-button"
            fetching={isSubmitting}
            hero
            // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
            onClick={onCreateDuplicate}
            text={intl.formatMessage({ id: "button.create" })}
          />
          <Button
            id="cancel-button"
            // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
            onClick={onCloseDuplicate}
            text={intl.formatMessage({ id: "button.cancel" })}
          />
        </div>
      </Form>
    );
  };

  return duplicateTags.length > 0 ? (
    <Formik
      id="duplicate-formik"
      // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
      onSubmit={onAssignDuplicate}
      validate={validateForm}
      initialValues={duplicateTags}
    >
      {renderForm}
    </Formik>
  ) : null;
}

export default injectIntl(InstrumentationDuplicateMoreTags);
